import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledStyleConfig = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  .config-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
  }

  .config-group-label {
    display: flex;
    align-items: center;
    height: 24px;
    width: 100%;
    color: ${COLOR.descriptionGray};
  }

  /* Các hàng trong một nhóm sát nhau hơn khoảng cách tới nhãn nhóm. */
  .config-group-rows {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }

  .config-divider {
    align-self: center;
    width: 320px;
    height: 0;
    margin: 0;
    border: none;
    border-top: 0.5px solid ${COLOR.indigo[16]};
  }
`;
